import { defaultAvatarColor, hexToRgba } from '../utils/avatarColors';

// A small pill showing a group's icon + name in the group's color. The color is
// the group's chosen `color` ("#RRGGBB"), or a deterministic palette color from
// its id — the same fallback rule as avatars, so groups look identical on web +
// iOS. Used on feed cards and the feed filter row.
export default function GroupChip({ name, icon, color, seed }) {
    const c = color || defaultAvatarColor(seed);
    return (
        <span
            className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap"
            style={{ backgroundColor: hexToRgba(c, 0.15), color: c }}
        >
            {icon ? <span aria-hidden="true">{icon}</span> : null}
            {name}
        </span>
    );
}
